import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css"; // Changed from index.css for simplicity, or create index.css
import "./index.css";
import App from "./App";
import { InterviewProvider } from "./contexts/InterviewContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <InterviewProvider>
      <App />
    </InterviewProvider>
  </React.StrictMode>
);
